const EnvConfig = {
  API_BASE_URL: '',
  IS_PRODUCTION: import.meta.env.MODE === 'production',
  IS_SENTRY_ENABLED: import.meta.env.MODE === 'production',
};

export default EnvConfig;
